import React from 'react';
import {Link, To} from 'react-router-dom'
import {BTN_STYLES, BTN_DISABLED_STYLES, DEFAULT_STYLE, DEFAULT_SIZE, SMALL_SIZE, SMALLER_SIZE} from "components/atom/button/styles.ts";

type PropsType = {
    style?: keyof typeof BTN_STYLES
    type?: string
    disabled?: boolean
    href?: string
    to?: To
    state?: any
    className?: string
    children?: React.ReactNode
    onClick?: (e: any) => void
    replace?: boolean
    rel?: string
    target?: string
    download?: boolean
    small?: boolean
    smaller?:boolean
    ariaLabel?: string
}

function Button(props: PropsType) {
    let Tag: any = 'button'

    const btnProps = {
        ...props
    }

    let style: keyof typeof BTN_STYLES = 'normal'

    //initial
    if (typeof props.type === 'undefined') {
        btnProps.type = 'button'
    }

    if (typeof props.disabled === 'undefined') {
        btnProps.disabled = false
    }

    //set
    if (typeof props.style !== 'undefined') {
        style = props.style
        delete btnProps.style//don't need it
    }


    if (typeof props.href !== 'undefined') {
        Tag = 'a'
        delete btnProps.type//don't need it
    }

    if (typeof props.to !== 'undefined') {
        Tag = Link
        delete btnProps.type//don't need it
    }

    const extraClassName = btnProps.className || ''
    const btnStyle = btnProps.disabled ? BTN_DISABLED_STYLES[style] : BTN_STYLES[style]

    let size = DEFAULT_SIZE
    if (props.small){
        size = SMALL_SIZE
    }
    if (props.smaller){
        size = SMALLER_SIZE
    }

    delete btnProps.className//don't need it
    delete btnProps.small//dont need it
    delete btnProps.smaller//dont need it
    delete btnProps.ariaLabel

    return (
        <Tag
            aria-label={props.ariaLabel}
            className={`${extraClassName} ${btnStyle} ${DEFAULT_STYLE} ${size}`}
            {...btnProps}
        >
            {props.children}
        </Tag>
    )
}

export default Button;
